var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchGlass({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 18.8225L14.7815 13.6041C16.137 11.9463 16.8035 9.83087 16.643 7.69543C16.4826 5.55999 15.5075 3.5679 13.9195 2.13123C12.3314 0.694554 10.252 -0.0767949 8.11119 -0.0232684C5.97039 0.0302581 3.93207 0.904564 2.41783 2.41881C0.903588 3.93305 0.0292815 5.97137 -0.024245 8.11216C-0.0777715 10.253 0.693577 12.3324 2.13025 13.9204C3.56693 15.5085 5.55901 16.4836 7.69445 16.644C9.82989 16.8044 11.9453 16.138 13.6032 14.7825L18.8215 20.0008L19.9998 18.8225ZM8.33315 15.0008C7.01461 15.0008 5.72568 14.6098 4.62935 13.8773C3.53302 13.1447 2.67854 12.1035 2.17395 10.8854C1.66937 9.66718 1.53735 8.32673 1.79458 7.03353C2.05182 5.74032 2.68676 4.55243 3.61911 3.62008C4.55146 2.68773 5.73934 2.05279 7.03255 1.79556C8.32576 1.53832 9.6662 1.67035 10.8844 2.17493C12.1025 2.67952 13.1437 3.534 13.8763 4.63033C14.6088 5.72665 14.9998 7.01559 14.9998 8.33413C14.9978 10.1016 14.2948 11.7962 13.045 13.046C11.7952 14.2958 10.1007 14.9988 8.33315 15.0008Z",
    fill: "#2E5666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGlass);
export default __webpack_public_path__ + "static/media/search-glass.bb0778f8e8bd3ebf3242aefe417addb0.svg";
export { ForwardRef as ReactComponent };